<template>
  <HeroSection
    title="Robotics Lab"
    subtitle="Simulate, control, and code your robotic arm."
    background-color="#e00069"
    background-image="/images/robotic-arm-challenges/hero-banner.png"
    illustration-image="/images/robotic-arm-challenges/hero-illustration.svg"
    illustration-alt="Robotics Lab"
  />
</template>

<script setup>
import HeroSection from "@/components/common/HeroSection.vue";
</script>
